module.exports = __webpack_public_path__ + "static/media/kasikon.a03cf5e3.png";